import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Home as HomeIcon, Facebook, Twitter, Instagram, Linkedin } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-[#F97316] rounded-lg flex items-center justify-center">
                <HomeIcon className="w-6 h-6 text-white" />
              </div>
              <div>
                <span className="text-xl font-bold tracking-tight" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                  CART GENIX
                </span>
                <span className="block text-xs text-slate-400 uppercase tracking-wider">Roof Repair Experts</span>
              </div>
            </Link>
            <p className="text-slate-400 mb-6">
              Professional roof repair services in Los Angeles. Licensed, bonded, and insured. 
              Available 24/7 for emergency repairs.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="heading-h3 text-white mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/services" className="footer-link">Our Services</Link></li>
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/service-areas" className="footer-link">Service Areas</Link></li>
              <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h3 className="heading-h3 text-white mb-6">Our Services</h3>
            <ul className="space-y-3">
              <li><Link to="/services" className="footer-link">Roof Leak Repair</Link></li>
              <li><Link to="/services" className="footer-link">Emergency Roof Repair</Link></li>
              <li><Link to="/services" className="footer-link">Storm Damage Repair</Link></li>
              <li><Link to="/services" className="footer-link">Roof Replacement</Link></li>
              <li><Link to="/services" className="footer-link">Shingle Repair</Link></li>
              <li><Link to="/services" className="footer-link">Commercial Roofing</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="heading-h3 text-white mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <div>
                  <a href="tel:+18884451244" className="footer-link font-semibold block">+1-888-445-1244</a>
                  <span className="text-sm text-slate-500">24/7 Emergency Line</span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <a href="mailto:support@cartgenix.store" className="footer-link">support@cartgenix.store</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <span className="text-slate-400">998 Sunset Boulevard<br />Los Angeles, CA 80021</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <div className="text-slate-400">
                  <p>Mon - Fri: 7:00 AM - 6:00 PM</p>
                  <p>Sat: 8:00 AM - 4:00 PM</p>
                  <p>Sun: Closed</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm text-center md:text-left">
              &copy; {currentYear} Cart Genix. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <Link to="/privacy-policy" className="footer-link" data-testid="footer-privacy">Privacy Policy</Link>
              <Link to="/terms" className="footer-link" data-testid="footer-terms">Terms & Conditions</Link>
              <Link to="/disclaimer" className="footer-link" data-testid="footer-disclaimer">Disclaimer</Link>
              <Link to="/contact" className="footer-link">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
